import React, { useState, useEffect, useRef } from "react";
import {
  CardBody,
  Col,
  Card,
  Container,
  UncontrolledPopover,
  PopoverBody,
  Button,
} from "reactstrap";
import * as moment from "moment";
import {
  getBillingInvoices,
  getInvoicesOfMonth,
} from "../../slices/general/thunk";
import { getAdminInvoices } from "../../slices/admin/thunk";
//redux
import { useDispatch } from "react-redux";
import { useCurrentUser } from "../../slices/auth/hooks";
import "react-toastify/dist/ReactToastify.css";
import BillingTable from "../../Components/Tables/BillingTable/BillingTable";
import Loading from "../../Components/Loading";
import { DASHBOARD_USER_ROLES } from "../../constants";
import { useParams } from "react-router-dom";
import { getNextBillingDate } from "../../utils/utils";
import SearchBar from "../../Components/SearchBar/SearchBar";
import NavTabBillings from "../../Components/Tabs/NavTabBillings";
import HeadersRole from "../../Components/Headers/HeadersRole";
import individualIcon from "../../assets/images/iconsRoles/IndividualsIcon.svg";

const DashboardBilling = () => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [loadingInvoiceOfMonth, setLoadingInvoiceOfMonth] = useState(false);
  const currentUser = useCurrentUser();
  const [invoices, setInvoices] = useState([]);

  const { id } = useParams();

  const [loadingPay, setLoadingPay] = useState(false);

  const [invoiceOfMonth, setInvoiceOfMonth] = useState(null);

  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [activeTab, setActiveTab] = useState("current-month");

  const [isBillingPaid, setIsBillingPaid] = useState(true);

  const isAdmin = currentUser.role === DASHBOARD_USER_ROLES.ADMIN;

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const toggleTab = (tab, status) => {
    const isPaid = status === "paid";

    if (activeTab !== tab) {
      setActiveTab(tab);
      setIsBillingPaid(isPaid);
      setInvoices([]);
      setCurrentPage(0);
    }
  };

  const fetchInvoicesOfMonth = async () => {
    const userInvoice = id ? id : currentUser.id;

    try {
      setLoadingInvoiceOfMonth(true);
      const res = await dispatch(getInvoicesOfMonth({ userId: userInvoice }));

      if (res.payload.error) {
        setInvoiceOfMonth(null);
      } else {
        setInvoiceOfMonth(res.payload);
      }
      setLoadingInvoiceOfMonth(false);
    } catch (error) {
      setLoadingInvoiceOfMonth(true);
      console.log(error);
      setLoadingInvoiceOfMonth(false);
    }
  };

  const fetchBillingInvoices = async () => {
    const userToFetch = id ? id : currentUser.id;

    try {
      setLoading(true);
      const res = await dispatch(
        getBillingInvoices({
          userId: userToFetch,
          paid: isBillingPaid,
          page: currentPage,
        })
      );

      setInvoices(res.payload.data);
      setTotalItems(res.payload.total);
      setPageSize(res.payload.pageSize);
      setTotalPages(res.payload.pages);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  const fetchBillingInvoicesAdmin = async () => {
    let status;
    let currentMonth;

    if (activeTab === "current-month") {
      currentMonth = "true";
    }

    if (activeTab === "invoices-paid") {
      status = "true";
    }
    if (activeTab === "invoices-due") {
      status = "false";
    }
    try {
      setLoading(true);
      const res = await dispatch(
        getAdminInvoices({ status: status, page: currentPage, currentMonth })
      );

      setInvoices(res.payload.data);
      setTotalItems(res.payload.total);
      setPageSize(res.payload.pageSize);
      setTotalPages(res.payload.pages);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  const handleRefreshTable = () => {
    setInvoices([]);
    if (isAdmin) {
      if (activeTab === "invoices-paid") {
        fetchBillingInvoicesAdmin();
      }

      if (activeTab === "current-month") {
        fetchInvoicesOfMonth();
      }
    } else {
      if (activeTab === "current-month") {
        fetchInvoicesOfMonth();
      }
      fetchBillingInvoices();
    }
  };

  useEffect(() => {
    if (isAdmin && !id) {
      if (activeTab === "current-month") {
        fetchBillingInvoicesAdmin();
      }

      if (activeTab === "invoices-paid") {
        fetchBillingInvoicesAdmin();
      }
      if (activeTab === "invoices-due") {
        fetchBillingInvoicesAdmin();
      }
    } else if (id && isAdmin) {
      if (activeTab === "current-month") {
        fetchInvoicesOfMonth();
      } else if (activeTab === "invoices-paid") {
        fetchBillingInvoices();
      } else if (activeTab === "invoices-due") {
        fetchBillingInvoices();
      }
    } else if (id) {
      fetchInvoicesOfMonth();
      fetchBillingInvoices();
    } else {
      fetchInvoicesOfMonth();
      fetchBillingInvoices();
    }
  }, [currentPage, activeTab]);

  const billingLabel = (
    <label htmlFor="like-input" className="form-label fw-semibold fs-6">
      <div>
        <span className="fs-15 text-muted fw-normal d-flex align-items-center">
          Next Billing Date:{" "}
          <span className="text-dark mx-2">{getNextBillingDate()}</span>{" "}
          <Button
            className="btn btn-xs py-0 px-1 btn-soft-primary border-primary rounded"
            id="billingDate"
          >
            Info
          </Button>
          <UncontrolledPopover
            trigger="hover"
            placement="right"
            target="billingDate"
          >
            <PopoverBody className="shadow-lg ">
              You can add or terminate employees until {getNextBillingDate()},
              at which point an invoice will be automatically generated for the
              employees listed as active or pending, making them active for{" "}
              {moment(getNextBillingDate())
                .add(1, "months")
                .startOf("month")
                .format("MM/DD/YYYY")}
              .
              <br />
              Any new employees or terminations after the billing date will be
              effective for the follllowing month.
            </PopoverBody>
          </UncontrolledPopover>
        </span>
      </div>
    </label>
  );

  return (
    <div className={id ? "mt-4" : "page-content px-0"}>
      <Container fluid>
        <HeadersRole
          role={isAdmin ? "Invoices" : "Billing"}
          icon={individualIcon}
          svg={true}
          text={billingLabel}
        />
        <div className={`mb-4 pb-3 ${id ? "" : "card"}`}>
          <div className={`${id ? "" : "card-body"}`}>
            {/* <div className="col-4 d-flex mt-1 justify-content-end mb-2">
              <SearchBar
                inputRef={inputRef}
                value={""}
                onChange={() => {}}
                shouldDisplaySearchBar={false}
                placeholder="Filter by name or email"
              />
            </div> */}

            {isAdmin && (
              <NavTabBillings
                loading={loading}
                toggleTab={toggleTab}
                activeTab={activeTab}
              />
            )}

            <Col xl={12}>
              <div className="table-container  position-relative">
                {(loadingInvoiceOfMonth || loading) && <Loading />}
                <div className="live-preview">
                  <div className="table-responsive ">
                    <BillingTable
                      isAdmin={isAdmin}
                      currentUser={currentUser}
                      loading={loading}
                      onRefresh={handleRefreshTable}
                      data={invoices}
                      activeTab={activeTab}
                      invoiceOfMonth={
                        activeTab === "current-month" ? invoiceOfMonth : null
                      }
                      paginationProps={{
                        currentPage,
                        totalPages,
                        totalItems,
                        pageSize,
                        onChangePage: handleChangePage,
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default DashboardBilling;
